export const DEFAULT_PRECISION = 2;
